exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert[data-v-1b278635]{width:400px;z-index:1070}", ""]);

// exports
